import { Inject, PLATFORM_ID, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { LocaleService } from '@app/core/i18n';
import { IjournalCategory } from './journal-main.interface';
import { isPlatformServer } from '@angular/common';

export const NB_ARTICLES_PER_PAGE = 12;

export const DEFAULT_CATEGORY: IjournalCategory = { title: 'All', uri: '', id: '' };

@Injectable({
  providedIn: 'root'
})
export class JournalMainService {
  private headers = this._getHeaders();

  constructor(
    private localeService: LocaleService,
    public httpClient: HttpClient,
    @Inject('SERVER_TIMEZONE') private timezone: string,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  private _request(path: string, meta: boolean = false) {
    const headers = this.headers;
    return <Observable<any>>this.httpClient.get(path, { headers }).pipe(
      map((res: any) => {
        if (meta && res.meta) {
          return res;
        }
        return res.data;
      }),
      catchError((err: HttpErrorResponse) => {
        console.error(err);
        return throwError(err);
      })
    );
  }

  getEditos(limit: number, page?: number, categoryUri?: string) {
    let path = `${environment.vccmsuri}/editos?limit=${limit}`;
    if (page) {
      path = `${path}&page=${page}`;
    }
    if (categoryUri && categoryUri !== DEFAULT_CATEGORY.uri) {
      path = `${path}&category=${categoryUri}`;
    }
    return this._request(path, true);
  }

  getCategories(): Observable<IjournalCategory[]> {
    const path = `${environment.vccmsuri}/editos-categories`;
    return this._request(path);
  }

  private _getHeaders() {
    return {
      'x-country': this.localeService.getCountry().toUpperCase(),
      'x-device-brand': 'other',
      'x-device-type': 'desktop',
      'x-lang-code': this._getFormatedLangCode(),
      'x-vc-timezone': isPlatformServer(this.platformId) && this.timezone ? this.timezone : '',
      'x-support-type': 'web',
      'x-vc-currency': this.localeService.getCurrency(),
      'x-vc-language': this.localeService.getLanguage(),
      'x-vc-siteid': this.localeService.getSiteId()
    };
  }

  private _getFormatedLangCode(): string {
    const langCode = this.localeService.getLocale();

    if (langCode.getRegion() === 'GB') {
      return `${langCode.getLanguage().toLowerCase()}_uk`;
    }
    return `${langCode.getLanguage().toLowerCase()}_${langCode.getRegion().toLowerCase()}`;
  }
}
